import { Trans } from '@lingui/react/macro';
import { LoadingNoteGeneration } from '@repo/videa-notes';

import { LoadingAnimation } from '@/common-components/animations/loading/LoadingAnimation';

export const NoteGenerationView = () => {
  return (
    <LoadingNoteGeneration
      loadingComponent={
        <LoadingAnimation
          translatedMessages={[
            <Trans key="1">Generating Audio Transcript...</Trans>,
            <Trans key="2">Generating Summary...</Trans>,
            <Trans key="3">Generating Clinical Note...</Trans>,
          ]}
        />
      }
    />
  );
};
